import { fetchExtensions } from '@/vuex/modules/integrations/integrations.utils';

const integrations = {
    namespaced: true,
    state: {
        installedIntegrations: [],
    },
    mutations: {
        setInstalledIntegrations (state, { installedIntegrations }) {
            state.installedIntegrations = installedIntegrations;
        },
    },
    actions: {
        async getInstalledIntegrations ({ commit }) {
            const installedIntegrations = await fetchExtensions();

            commit('setInstalledIntegrations', { installedIntegrations });
        },
    },
};

export default integrations;
